// extracted by mini-css-extract-plugin
export default {"wrapper":"Io-z","response":"Jo-z","error":"Ko-z","disabled":"Lo-z","buttons":"Mo-z","feedbackQuestionSection":"No-z","yesNoWrapper":"Oo-z"};